import { render, staticRenderFns } from "./SurgeryInvoices.vue?vue&type=template&id=505fd83e"
import script from "./SurgeryInvoices.vue?vue&type=script&lang=js"
export * from "./SurgeryInvoices.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports